import { CalendarDaysIcon, SparklesIcon } from '@heroicons/react/24/solid';

import { Badge } from './Badge';
import { UpgradeToPremiumBadge } from './UpgradeToPremiumBadge';
import { PremiumBadge } from './PremiumBadge';

type Props = {
  subscriptionStatus: string
}

export const SubscriptionBadge = ({ subscriptionStatus }: Props) => {
  if (subscriptionStatus === 'unlimited') {
    return (
      <Badge className='bg-yellow-200 ring-yellow-300 text-neutral-700'>
        <SparklesIcon className='size-3 mr-2' />
        Unlimited
      </Badge>
    );
  }
  else if (subscriptionStatus === 'trialing') {
    return (
      <Badge className='bg-blue-200 ring-blue-300 text-neutral-700'>
        <CalendarDaysIcon className='size-3 mr-2' />
        Free Trial
      </Badge>
    );
  }
  else if (subscriptionStatus === 'active') {
    return <PremiumBadge />;
  }
  else {
    return <UpgradeToPremiumBadge />;
  }
};
